import React , { useState , useEffect }from 'react';
import webapi from '../../../api/webapi';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Pagination/*, Navigation*/ } from 'swiper/modules';

import Img2 from './img2';

const TopBooks = (props) => {
    const [topBooks,setTopBooks] = useState(undefined)
    const[parsigTextShow,setParsigTextShow] = useState(undefined)
    
    useEffect(()=>{
        async function getPage() {
            //console.log('languageInfo[0]:'+props.languageInfo[0].Code);
            await webapi.get('book/topbooks/'+props.languageInfo[0].Code)
                .then((res)=>{
                    //console.log('res.data1:',res.data)
                    setTopBooks(res.data);
                    //console.log('topBooks1:',topBooks)
                })
        
            await webapi.get('pages/config/1/'+props.languageInfo[0].Code)
                .then((res)=>{
                    setParsigTextShow(res.data.filter((val)=>{
                        if(val.Item.toLowerCase()==='ParsigTextShow'.toLowerCase()){
                            return val;
                        }
                        else
                        {
                            return null;
                        }
                    }))
                })
        }
        
        getPage();
    },[props.languageInfo])
    

    if (parsigTextShow && parsigTextShow[0].Value && parsigTextShow[0].Value==='1' && 
        props.pageData && props.languageInfo){
        return (
            <div className="container-fluid" id="firstpage_row_4" style={{direction:'ltr'}}>
                <div className="container">
                    <div id="firstpage_row_4_text">
                        <h4>{props.pageData.length!==0 && props.pageData[0].F102!== undefined?props.pageData[0].F102:102/*متون پارسیگ*/}</h4>
                        <hr />
                        <Swiper
                            modules={[Pagination]}
                            spaceBetween={10}
                            slidesPerView={1}
                            //loop={true}
                            pagination={{ clickable: true }}
                            navigation
                            breakpoints={{
                                // وقتی عرض صفحه ۶۴۰ پیکسل یا بیشتر شد
                                500: {
                                    slidesPerView: 1,
                                    //spaceBetween: 20,
                                },
                                650: {
                                    slidesPerView: 2,
                                    //spaceBetween: 20,
                                },
                                // وقتی عرض صفحه ۷۶۸ پیکسل یا بیشتر شد
                                768: {
                                slidesPerView: 3,
                                //spaceBetween: 30,
                                },
                                // وقتی عرض صفحه ۱۰۲۴ پیکسل یا بیشتر شد (دسکتاپ)
                                992: {
                                slidesPerView: 4,
                                //spaceBetween: 40,
                                },
                                1200: {
                                slidesPerView: 5,
                                //spaceBetween: 40,
                                },
                            }}
                        >
                            {
                                (topBooks)
                                ?
                                topBooks.map((topBook) =>{
                                    return  (
                                        <SwiperSlide className='swiper-item'>
                                            <div >
                                                {
                                                    (topBook.FormStatusCode.toLowerCase()==="bs_loading")
                                                    ?
                                                    <span className="new_badge">{props.pageData.length!==0 && props.pageData[0].F10205!== undefined?props.pageData[0].F10205:10205/*جدید*/}</span>
                                                    :
                                                    null
                                                }
                                                <Img2 
                                                    Class="book_img"
                                                    ImageCode={topBook.Code}
                                                />
                                                <p className="book_title">
                                                    <a href={process.env.PUBLIC_URL+"/book/"+topBook.Code}>{topBook.Title}</a>
                                                </p>
                                                <p className="book_summary">{topBook.Note}</p>
                                                <p className="book_stat">{topBook.Description}</p>
                                                <p className="book_number"><span className="circle">{topBook.Field2}</span></p>
                                                <br/> 
                                                <br/>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                                :
                                null
                            }
                        </Swiper>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default TopBooks;